import * as React from 'react';
import { useInputSize } from '../../../internal/hooks';
import { getInputAdornmentStyles } from '../../styles';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Элемент с отступами для использования в качестве декорации инпута
 */
export function InputAdornment(_ref) {
  var children = _ref.children;
  var size = useInputSize();
  var styles = getInputAdornmentStyles(size);
  return /*#__PURE__*/_jsx("div", {
    className: styles['input-adornment'],
    children: children
  });
}